import { useDispatch } from "react-redux"
import styled from "styled-components"
import { handleActiveSelect } from "../../../../features/layout/layoutSlice"
import { useSelector } from "react-redux"
import { setTimeData } from "../../../../features/admin4/admin4Slice"

const Container = styled.div`
    width: ${({inputWidth}) => inputWidth};
    position: relative;

    .selected-time{
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        height: 40px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-left: 15px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
        cursor: pointer;
    }

    .time-select-container{
        display: flex;
        align-items: center;
        position: absolute;
        width: 100%;


    }

    .hour-list{
        width: 50%;
        display: flex;
        flex-direction: column;
        max-height: 200px;
        overflow: auto;
        scrollbar-width: none; /* Firefox'ta scroll'u gizler */
        -ms-overflow-style: none; /* Eski Internet Explorer tarayıcıları için */
        border-left: 1px solid ${({theme}) => theme.mainBorderColor};
        
        &-webkit-scrollbar {
             display: none; /* Webkit tarayıcıları için scroll'u gizler */
        }

        .item{
            width: 100%;
            height: 40px !important;
            padding: 10px 0;
            background-color: ${({theme}) => theme.mainBgColor};
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            border: 1px solid transparent;
            font-weight: var(--font-weight-md);
            border-bottom: 1px solid ${({theme}) => theme.mainBorderColor};

            &:hover{
                background-color: ${({theme}) => theme.secondaryBgColor};
            }
        }
       
        .active{
            background-color: var(--color-main);
            color: #fff;
        }
    }

    .minute-list{
        width: 50%;
        display: flex;
        flex-direction: column;
        max-height: 200px;
        overflow: auto;
        scrollbar-width: none; /* Firefox'ta scroll'u gizler */
        -ms-overflow-style: none; /* Eski Internet Explorer tarayıcıları için */
        border-right: 1px solid ${({theme}) => theme.mainBorderColor};
        border-left: 1px solid ${({theme}) => theme.mainBorderColor};

        &-webkit-scrollbar {
             display: none; /* Webkit tarayıcıları için scroll'u gizler */
        }

        .item{
            width: 100%;
            height: 40px !important;
            padding: 10px 0;
            background-color: ${({theme}) => theme.mainBgColor};
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            border: 1px solid transparent;
            font-weight: var(--font-weight-md);
            border-bottom: 1px solid ${({theme}) => theme.mainBorderColor};

            &:hover{
                background-color: ${({theme}) => theme.secondaryBgColor};
            }   
        }

        .active{
            background-color: var(--color-main);
            color: #fff;
        }
       
    }



`

const TimeInput = ({inputWidth}) => {

    const dispatch = useDispatch()


    const {
        timeData
    } = useSelector(state => state.admin4)

    const {
        activeSelect
    } = useSelector(state => state.layout)

    const handleClick = (type, data) => {

        if(type === "hour"){
            dispatch(setTimeData({hour: data.toString().padStart(2, "0"), minute: timeData.minute ? timeData.minute.toString().padStart(2, "0") : "00" }))
        }

        else{
            dispatch(setTimeData({minute: data.toString().padStart(2, "0"), hour: timeData.hour ? timeData.hour.toString().padStart(2, "0"): "12" }))
        }
    }

    

  return (
    <Container inputWidth={inputWidth}>

        <div className="selected-time" onClick={() => dispatch(handleActiveSelect((activeSelect && activeSelect === "time-selected") ? null : "time-selected"))}>{timeData.hour ? `Saat ${timeData.hour}:${timeData.minute}' da gönderilecek` : "Saat seçin"}</div>
        {
            activeSelect === "time-selected" &&
            <div className="time-select-container">
                <div className="hour-list">
                    {
                        Array.from({ length: 24 }).map((_, index) => (
                            <div className={(timeData.hour && timeData.hour.toString().padStart(2, "0") === (index).toString().padStart(2, "0")) ? "active item" : "item"} onClick={() => handleClick("hour", index)}>{index.toString().length < 2 ? `0${index}` : index}</div>
                        ))
                    }
                </div>
                <div className="minute-list">
                    {
                        Array.from({ length: 60 }).map((_, index) => (
                            <div className={(timeData.minute && timeData.minute.toString().padStart(2, "0") === (index).toString().padStart(2, "0")) ? "active item" : "item"} onClick={() => handleClick("minutes", index)}>{index.toString().length < 2 ? `0${index}` : index}</div>
                        ))
                    }
                </div>

            </div>
        }

    </Container>
  )
}

export default TimeInput